import { Bone, SkeletonGrid } from '../primitives';

// Matches WelcomePage.js's grid of big image+title "use case" cards.
export default function WelcomePageSkeleton() {
    return (
        <div className="container">
            <Bone h={26} w={320} style={{ margin: '32px auto 24px' }} />
            <SkeletonGrid cols={2} gap={16}>
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 14 }}>
                        <Bone h={140} r={10} style={{ marginBottom: 12 }} />
                        <Bone h={14} w="60%" />
                    </div>
                ))}
            </SkeletonGrid>
        </div>
    );
}
